import React from 'react'

export default () => (
  <footer>
    <p
      style={{
        marginTop: 100,
        textAlign: 'right',
      }}
    >
      Created by Kacper -{' '}
      <a href="https://twitter.com/caspg_">Twitter</a> -{' '}
      <a href="https://github.com/caspg">GitHub</a>
    </p>
  </footer>
)



/** WEBPACK FOOTER **
 ** ../components/Footer.jsx
 **/